import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../../../tenancy/TenantContext';
import { addTenantQueryToPath } from '../../../auth/adminAccess';

const MissingSubscriptionPage: React.FC = () => {
  const navigate = useNavigate();
  const { tenantId } = useTenant();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
      }}
    >
      <Stack spacing={3} alignItems="center" textAlign="center" maxWidth={400}>
        <Typography variant="h4" fontWeight={700}>
          Subscription Required
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Your access is restricted until the subscription owner updates the plan. Please contact your admin or try again later.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(addTenantQueryToPath('/admin', tenantId))}>
          Try Again
        </Button>
        <Button variant="contained" color="primary" onClick={() => navigate('/')}>
          Return to Homepage
        </Button>
      </Stack>
    </Box>
  );
};

export default MissingSubscriptionPage;
